import { useMemberId } from '@trello/authentication';
import { useIsMemberOfOrganization } from '@trello/business-logic-react/organization';
import { useFeatureGate } from '@trello/feature-gate-client';

import { useHasReverseTrialExperienceQuery } from './HasReverseTrialExperienceQuery.generated';
import { useFreeTrialEligibilityRules } from './useFreeTrialEligibilityRules';

export const useHasReverseTrialExperience = (workspaceId: string) => {
  const { data } = useHasReverseTrialExperienceQuery({
    variables: { workspaceId: workspaceId || '' },
    skip: !workspaceId,
    waitOn: [],
  });

  const workspace = data?.organization;

  const { isExpired: isFreeTrialExpired } = useFreeTrialEligibilityRules(
    workspace?.id,
    { skip: !workspace?.id },
  );

  const memberId = useMemberId();

  const isMemberOfWorkspace = useIsMemberOfOrganization({
    idMember: memberId,
    idOrganization: workspace?.id,
  });

  const { value: isGateEnabled } = useFeatureGate(
    'trello_enterprise_reverse_trial_experience',
  );

  if (!isGateEnabled) {
    return false;
  }

  if (!workspace?.id) {
    return false;
  }

  if (!isMemberOfWorkspace) {
    return false;
  }

  // workspace not in reverse trial cohort
  if (workspace.reverseTrialTag !== 'q4_actual_experiment') {
    return false;
  }

  // workspace does NOT have a premium trial created via reverse trial
  if (
    !workspace?.credits?.some(
      (credit) => credit.type === 'freeTrial' && credit.via === 'reverse-trial',
    )
  ) {
    return false;
  }

  if (isFreeTrialExpired) {
    return false;
  }

  return true;
};
